import { Button, Input, Modal } from "antd";
import React, { Dispatch, useState } from "react";

const ModalReference = (props: { modal: boolean, setModal: Dispatch<boolean>, add: any }) => {
  const [sku, setSku] = useState<string>("")
  const [shortWording, setShortWording] = useState<string>("")
  const [longWording, setLongWording] = useState<string>("")

  return (
    <Modal title="Ajout de référence" open={props.modal} onCancel={() => props.setModal(false)}
      onOk={() => props.setModal(false)}
      footer={[
        <Button onClick={() => props.setModal(false)}>Annuler</Button>,
        <Button onClick={() => { props.add(sku, shortWording, longWording); props.setModal(false) }}>Ajouter</Button>,
      ]}>
      <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "1rem" }}>
        <span>SKU</span>
        <Input placeholder="SKU" onChange={(e) => setSku(e.target.value)} style={{ width: '80%', alignContent: "flex-end" }} />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "1rem" }}>
        <span>Libellé court</span>
        <Input placeholder="Libellé court" onChange={(e) => setShortWording(e.target.value)} style={{ width: '80%', alignContent: "flex-end" }} />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "1rem" }}>
        <span>Libellé long</span>
        <Input placeholder="Libellé long" onChange={(e) => setLongWording(e.target.value)} style={{ width: '80%', alignContent: "flex-end" }} />
      </div>
    </Modal>
  )
}

export default ModalReference